import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

type NavAction = "push" | "replace";

/**
 * useNavigateToUri
 * - External http/https => full page navigation
 * - Internal path => navigate push/replace
 */
export function useNavigateToUri() {
  const navigate = useNavigate();

  return useCallback(
    function (url: string, action: NavAction = "push") {
      if (/^https?:\/\//i.test(url)) {
        window.location.href = url;

        return;
      }

      if (action === "replace") {
        navigate(url, { replace: true });
      } else {
        navigate(url);
      }
    },
    [navigate]
  );
}
